export default __webpack_public_path__ + "static/media/react.a96b343c.svg";